import React from 'react';
import { Check } from 'lucide-react';
import Icon from '../../../components/AppIcon';

const FeatureShowcaseCard = ({ feature, isSelected, onClick }) => {
  const colorClasses = {
    primary: 'bg-primary/10 text-primary border-primary/20',
    success: 'bg-success/10 text-success border-success/20',
    warning: 'bg-warning/10 text-warning border-warning/20',
    accent: 'bg-accent/10 text-accent border-accent/20'
  };

  const selectedClasses = {
    primary: 'border-primary shadow-therapeutic-lg',
    success: 'border-success shadow-therapeutic-lg',
    warning: 'border-warning shadow-therapeutic-lg',
    accent: 'border-accent shadow-therapeutic-lg'
  };

  return (
    <div
      onClick={onClick}
      className={`
        bg-card rounded-xl border-2 p-6 cursor-pointer transition-all
        hover:shadow-therapeutic-md
        ${isSelected ? selectedClasses?.[feature?.color] : 'border-border'}
      `}
    >
      <div className="flex items-start gap-4 mb-4">
        <div className={`flex-shrink-0 w-14 h-14 rounded-lg flex items-center justify-center ${colorClasses?.[feature?.color]}`}>
          <Icon name={feature?.icon} size={28} strokeWidth={2} />
        </div>
        <div className="flex-1">
          <h3 className="text-xl font-heading font-bold text-foreground mb-2">
            {feature?.title}
          </h3>
          <p className="text-muted-foreground text-sm">
            {feature?.description}
          </p>
        </div>
      </div>

      <div className="space-y-2">
        {feature?.benefits?.map((benefit, index) => (
          <div key={index} className="flex items-start gap-2">
            <Check className="w-5 h-5 text-success flex-shrink-0 mt-0.5" />
            <span className="text-sm text-foreground">{benefit}</span>
          </div>
        ))}
      </div>

      {isSelected && (
        <div className="mt-4 pt-4 border-t border-border">
          <p className="text-xs text-primary font-semibold">
            Click "See It In Action" below to preview this feature
          </p>
        </div>
      )}
    </div>
  );
};

export default FeatureShowcaseCard;